import * as React from "react";
import { RouteComponentProps } from "react-router";
import {
  Row,
  Col,
  CardBody,
  Table,
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
  FormGroup,
  Label,
  Form
} from "reactstrap";
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import { getReport, listCards } from "../../graphql/queries";
import { createTransaction, createCompanyReport } from "src/graphql/mutations";
import {
  CreateTransactionMutation,
  CreateTransactionMutationVariables,
  CreateCompanyReportMutation,
  CreateCompanyReportMutationVariables
} from "src/API";

/** Presentation/UI */
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import { MdKeyboardArrowLeft } from "react-icons/md";
import StyledButton from "../../Components/Styled/Button";
import Link from "../../Components/Styled/Link";
import colors from "src/Themes/Colors";
import styled from "styled-components";
import Card from "../../Components/Styled/Card";
import LargeInput from "../../Components/Styled/Input";

import PageLoader from "../../Components/PageLoader";
import Loader from "../../Components/Loader";

import GlobalModalContainer from "../../Components/Modal";

interface IPathParams {
  id: string;
}

type Props = RouteComponentProps<IPathParams> & {
  computedMatch: {
    params: {
      id: string;
    };
  };
  reportData: {};
  closeModal(): void;
};

type State = {
  voucher: string;
  discountPrice: string;
  companyId: string;
  reportData: any;
  modal: boolean;
};

const Line = styled.label`
  padding: 1px;
  background: ${colors.coal};
  display: block;
  margin: 20px 0px;
`;

class Checkout extends React.Component<Props, State> {
  state: State = {
    voucher: "",
    discountPrice: "",
    companyId: "",
    reportData: {},
    modal: false
  };

  // Open checkout modal with passed checkout data
  openModal = (report: any, discount: any) => {
    this.setState({ modal: true, reportData: report, voucher: discount });
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Handle change in input fields
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "voucher":
        this.setState({ voucher: value });
        break;
      default:
        break;
    }
  };

  // show list of cards for company
  listCards = (cards: any) => {
    const cardList = cards.items.map((data: any) => (
      <Label key={data.card.id}>
        <Input type="radio" name={data.card.id} />
        Card ending ******{data.card.number.slice(12, 16)}
      </Label>
    ));
    return cardList;
  };

  render() {
    const { voucher, discountPrice } = this.state;
    let { reportData, companyId } = this.state;

    return (
      <React.Fragment>
        <GlobalModalContainer
          toggleModal={this.closeModal}
          title="Confirm Report Purchase"
          modalDisplay={
            <Mutation<
              CreateTransactionMutation,
              CreateTransactionMutationVariables
            >
              mutation={gql(createTransaction)}
            >
              {(createTransactionMutation, response) => (
                <Mutation<
                  CreateCompanyReportMutation,
                  CreateCompanyReportMutationVariables
                >
                  mutation={gql(createCompanyReport)}
                >
                  {createCompanyReportMutation => (
                    <Form
                      onSubmit={e => {
                        e.preventDefault();
                        createTransactionMutation({
                          variables: {
                            input: {
                              // TODO: get company card once amplify has been sorted
                              transactionCardId: "",
                              transactionReportId: reportData.id,
                              transactionCompanyId: companyId
                            }
                          }
                        }).then((res: any) => {
                          createCompanyReportMutation({
                            variables: {
                              input: {
                                companyReportCompanyId: companyId,
                                companyReportReportId: reportData.id
                              }
                            }
                          });
                        });
                      }}
                    >
                      <Row>
                        <Col sm={12} md={12} lg={12}>
                          <h3>Buying {reportData.name}</h3>
                          <Line />
                          <h5>Summary</h5>
                          <h6>Tax : R 0.00</h6>
                          <Line />
                          <h5>
                            Order Total(incl. Vat): R{" "}
                            {discountPrice ? discountPrice : reportData.price}
                          </h5>
                          <StyledButton
                            type="submit"
                            label={!response.loading ? "Buy" : <Loader />}
                            width="100%"
                            color={colors.snow}
                            background={colors.default}
                            margin="5px"
                          />
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Mutation>
              )}
            </Mutation>
          }
          modal={this.state.modal}
        />
        <BackendWrapper>
          <Row>
            <Col sm={12} md={12} lg={12}>
              <Link
                to={{
                  pathname: "/consumer/reports"
                }}
                color={colors.coal}
                label={
                  <p style={{ fontSize: "17px" }}>
                    <MdKeyboardArrowLeft size="2em" /> Back
                  </p>
                }
              />
            </Col>
            <Col sm={12} md={12} lg={12}>
              <h4>Checkout</h4>
            </Col>
            <Col sm={12} md={12} lg={12}>
              <Card>
                <CardBody>
                  <Query
                    query={gql(getReport)}
                    variables={{
                      limit: 1,
                      id: this.props.computedMatch.params.id
                    }}
                  >
                    {({ loading, data }) => {
                      if (loading) {
                        return <PageLoader />;
                      }
                      if (!loading && data) {
                        reportData = data.getReport;
                        return (
                          <Col sm={12} md={12} lg={12}>
                            <Table striped={true}>
                              <thead>
                                <tr>
                                  <th>ITEM</th>
                                  <th>MAX DOWNLOADS</th>
                                  <th>COST</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th scope="row">{reportData.name}</th>
                                  <td>{reportData.maxDownloads}</td>
                                  <td>R {reportData.price}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        );
                      } else {
                        return (
                          <p>There has been a problem loading your cart</p>
                        );
                      }
                    }}
                  </Query>
                  <Col sm={12} md={6} lg={6}>
                    <InputGroup>
                      <LargeInput
                        type="text"
                        name="voucher"
                        id="voucher"
                        value={voucher}
                        placeholder="Enter your code"
                        height={"40px"}
                        onChange={this.handleChange}
                      />
                      <InputGroupAddon addonType="append">
                        <Button>Apply Voucher</Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </Col>
                  <Line />
                  <Row>
                    <Col sm={12} md={6} lg={6}>
                      <h3>Payment Method</h3>
                      <FormGroup>
                        <Col sm={12} md={12} lg={12}>
                          <Query query={gql(listCards)}>
                            {({ loading, data }) => {
                              if (loading) {
                                return <Loader />;
                              }

                              if (!loading && data) {
                                companyId = data.listCompanyCards.company.id;
                                return this.listCards(data.listCompanyCards);
                              } else {
                                return (
                                  <Col sm={12} md={12} lg={12}>
                                    <p>There are no cards</p>
                                    <Link
                                      to={{
                                        pathname: "/consumer/account"
                                      }}
                                      label={
                                        <StyledButton
                                          type="button"
                                          label="Add New Card"
                                          width="120px"
                                          color={colors.snow}
                                          background={colors.default}
                                          margin="5px"
                                        />
                                      }
                                    />
                                  </Col>
                                );
                              }
                            }}
                          </Query>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm={12} md={6} lg={6}>
                      <h3>Summary</h3>
                      <h6>Tax : R 0.00</h6>
                      <Line />
                      <h5>
                        Order Total: R{" "}
                        {discountPrice ? discountPrice : reportData.price}
                      </h5>
                      <StyledButton
                        type="submit"
                        label="CHECKOUT"
                        width="100%"
                        color={colors.snow}
                        background={colors.default}
                        margin="5px"
                        onClick={() =>
                          this.openModal(reportData, discountPrice)
                        }
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </BackendWrapper>
      </React.Fragment>
    );
  }
}
export default Checkout;



// WEBPACK FOOTER //
// ./src/Containers/Checkout/index.tsx